import React, {Component} from 'react'
import {Router, browserHistory} from 'react-router'
import {StyleRoot} from 'radium'
import google from '../analytics/google'
import mixpanel from '../analytics/mixpanel'
import routes from './routes'
import '../analytics/identify'
import {GAnalytics} from '../config'

const history = browserHistory

google.initialize(GAnalytics)

const logPageView = () => {
  const page = window.location.pathname
  mixpanel.track(`page views`, {
    page: page,
  })
  google.set({page})
  google.pageview(page)
}

class Root extends Component {
  render() {
    return (
      <StyleRoot>
          <Router history={history} routes={routes} onUpdate={logPageView} />
      </StyleRoot>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/app/root.js